import { Injectable, OnInit } from "@angular/core";
import DataService from "./data.service";
import ExceptionService from "./exception.service";
import ToastService from "./toast.service";
import { Router } from "@angular/router";
import UserService from "./user.service";

@Injectable({
    providedIn: "root",
})
export class ImpersonateService implements OnInit {
    private _isImpersonating: Boolean = false;

    constructor(
        private router: Router,
        private dataService: DataService,
        private exceptionService: ExceptionService,
        private userService: UserService,
        private toastr: ToastService
    ) {}

    get isImpersonating() {
        return this._isImpersonating;
    }

    ngOnInit() {
        this.checkImpersonation();
    }

    checkImpersonation(): Promise<boolean> {
        return this.dataService
            .getApi<boolean>(`Impersonate/IsImpersonating`)
            .then((isImpersonating) => {
                this._isImpersonating = isImpersonating;
                return isImpersonating;
            })
            .catch((error) => {
                this._isImpersonating = false;
                this.exceptionService.handleException(error);
                return false;
            });
    }

    stopImpersonating() {
        this.checkImpersonation().then((isImpersonating) => {
            if (isImpersonating) {
                this.dataService
                    .getApi(`Impersonate/Stop`)
                    .then(() => {
                        this.toastr.success("Successfully stopped impersonating.");
                        this.router.navigate(["/"]).then(() => window.location.reload());
                    })
                    .catch((error) => {
                        this.exceptionService.handleException(error);
                    })
                    .finally(() => {
                        this.checkImpersonation();
                    });
            } else {
                this.toastr.error("Unable to stop Impersonating, not currently impersonating a user.");
            }
        });
    }

    StartImpersonation(email: string) {
        this.userService.isAuthorized("SysAdmin").then((result) => {
            if (result.Authorized) {
                this.checkImpersonation().then((isImpersonating) => {
                    if (isImpersonating) {
                        this.toastr.error("Unable to Impersonate when currently impersonating.");
                    } else {
                        this.dataService
                            .getApi(`Impersonate/${email}`)
                            .then(() => {
                                this.toastr.success(`Successfully started impersonating ${email}`);
                                this.userService.user = null;
                                this.router.navigate(["/"]).then(() => window.location.reload());
                            })
                            .catch((error) => {
                                this.exceptionService.handleException(error);
                            })
                            .finally(() => {
                                this.checkImpersonation();
                            });
                    }
                });
            } else {
                this.toastr.warning("Unable to perform action, missing necessary permissions.");
            }
        });
    }
}
